import { ActionReducerMap } from '@ngrx/store';

import { fhirResourcesFeatureKey, IFhirResourcesState } from '@hestia/ngx-fhir';
import {
  qnrModuleSettingsFeatureKey,
  qnrFormSessionFeatureKey,
  IQnrFormSessionsState,
  IUserControlledSettingsState,
} from '@hestia/ngx-fhir-qnr-forms';
import { userFeatureKey, IHestiaUserState } from '@hestia/ngx-user';

import {
  dawbaSpecificFeatureKey,
  dawbaSpecificReducer,
  IDawbaSpecificState,
} from './+dawba-specific/dawba-specific.reducer';

export const reducers: ActionReducerMap<unknown> = {
  [dawbaSpecificFeatureKey]: dawbaSpecificReducer,
};

export interface IDawbaAppState {
  [dawbaSpecificFeatureKey]: IDawbaSpecificState;
  [userFeatureKey]: IHestiaUserState;
  [fhirResourcesFeatureKey]: IFhirResourcesState;
  [qnrFormSessionFeatureKey]: IQnrFormSessionsState;
  [qnrModuleSettingsFeatureKey]: IUserControlledSettingsState;
}
